export { EditJob } from './edit-job';
import { EditJob } from './edit-job';
import { EditJobProvider } from './edit-job.provider';

export const FeatureEditJob = () => {
   return (
      <EditJobProvider>
         <EditJob></EditJob>
      </EditJobProvider>
   );
};
